
import React, { useState, useEffect } from "react";
import ArrowBackIosNew from "@mui/icons-material/ArrowBackIosNew";
import { toast } from 'react-toastify';

import { useNavigate, useLocation } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import { authKey, BULK_APPROVE_PO, GET_SCHEDULE_APPROVAL_LIST, APPROVE_WEEKLY_SCHEDULE, DELETE_SCHEDULE } from '../../../common/URLs';
import jwt from 'jwt-decode';
import SearchIcon from "@mui/icons-material/Search";
import DatePicker from "react-datepicker";
import moment from 'moment';
import { Container, TextField, Grid, Button, Box, Card, Tooltip, IconButton, Popover, Stack, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, Typography, Tab } from '@mui/material'
import { DataGrid } from '@mui/x-data-grid';
import { QuickSearchToolbar } from '../../../payment/common/commonFunctions';
import { loaderService } from "../../../common/custom-loader/loader-service";
import { CheckBox } from "@mui/icons-material";
import { DialogContent, Dialog, DialogActions } from '@mui/material';
import { ConfirmPopover } from "../../../preregcamps/confirmPopover/confirmPopover";
import { ErrorPopover } from '../../../common/ErrorPopover/errorPopover';
import { getLocalStorageItem } from "../../../common/localStorageUtils";
import { PROD, PIT_ROLES } from "../../../common/constants";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import Swal from 'sweetalert2';
import Badge from 'react-bootstrap/Badge';
import { VALIDATION, capitalizeFunction } from "../../../common/commonValidations";
import { ConfirmationPopover } from "../../../common/commonPopovers/confirmationPopover";
import { ApproveIcon } from "../../../common/icons";
import apiClient from "../../../axios";
import DeleteIcon from '@mui/icons-material/Delete';

function ChippingApproval() {

    const role = localStorage.getItem('role');
    const isPlantOperator = [PIT_ROLES?.PlantSCMOperator, PIT_ROLES?.PitProcessingPlant].includes(role)
    const navigate = useNavigate();
    const { state } = useLocation();
    const [asnDetails, setAsnDetails] = useState([]);
    const [selected, setSelected] = useState(asnDetails);
    const [searchFilter, setSearchFilter] = useState({
        "consignmentNo": "",
        "grnDate": "",
        // "materialtype":""
    });
    const decoded = jwt(getLocalStorageItem('id_token'));
    const [stakeholderDetails, setStakeholderDetails] = useState({});
    const [scheduleListData, setscheduleListData] = useState();
    const [bulkApprovePo, setbulkApprovePo] = useState();
    const [addComment, setAddComment] = useState('');
    const [characterLimit] = useState(500);
    const [errorMessage, setErrorMessage] = useState({
        noRecordError: '',
    });
    // const [logModalOpen, setLogModalOpen] = useState(false);
    const handleLogModalOpen = () => setLogModalOpen(true);
    const handleLogModalOpen1 = () => setLogModalOpen(true);

    const [logModalOpen, setLogModalOpen] = useState(false);
    const [logModalOpen2, setLogModalOpen2] = useState(false);
    const handleLogModalOpen2 = () => setLogModalOpen2(true);
    const handleLogModalClose2 = () => { setLogModalOpen2(false); getScheduleList(); }
    const [scheduleList, setscheduleList] = useState([]);
    const [open, setOpen] = React.useState(false);
    const [tabValue, setTabValue] = useState(state?.tabValue ? state?.tabValue : "Pending");
    const [fromDate, setFromDate] = useState(new Date());
    const [toDate, setToDate] = useState(new Date());

    const [scheduleToDelete, setScheduleToDelete] = useState();
    const [deletedSchedules, setDeletedSchedules] = useState();

    const [confirmOpen, setConfirmOpen] = useState(false);
    const handleConfirmOpen = () => setConfirmOpen(true);
    const handleConfirmClose = () => setConfirmOpen(false);

    const [confirmOpen2, setConfirmOpen2] = useState(false);
    const handleConfirmOpen2 = () => setConfirmOpen2(true);
    const handleConfirmClose2 = () => setConfirmOpen2(false);

    const [confirmOpen3, setConfirmOpen3] = useState(false);
    const handleConfirmOpen3 = () => setConfirmOpen3(true);
    const handleConfirmClose3 = () => setConfirmOpen3(false);


    useEffect(() => {
        getScheduleList();
    }, [tabValue]);


    const getScheduleList = (e) => {
        loaderService.showLoader();
        apiClient
            .post(GET_SCHEDULE_APPROVAL_LIST,
                {
                    "type": tabValue,
                    "isChippingSchedule": true,
                    "destinationStakeHolderType": isPlantOperator ? "Plant" : "",
                    "destinationStakeHolderUrn": isPlantOperator ? "ABEPL" : "",
                    "stakeholderType": getLocalStorageItem('role') === PIT_ROLES?.PitProcessingLLE ? "LLE" : '',
                },
                {
                    headers: {
                        Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    }
                }, null
            )
            .then((response) => {
                setscheduleListData(response.data.weeklySchedulePlanDetailsList);
                loaderService.hideLoader();
            })
            .catch(function (error) {
                console.log(error);
                loaderService.hideLoader();
                toast.error(error.message);
            });
    }

    const onViewDetails = (cellValues) => {
        navigate('./growerPo', {
            state: { selectedRow: cellValues.row }
        });
    }

    const columns = [
        { field: 'weeklyScheduleNumber', headerName: 'Schedule No', width: 250 },
        { field: 'scheduleLineNumber', headerName: 'Schedule Line No', width: 150 },
        {
            field: 'schedulePickupDate', headerName: 'Pick up Date', width: 150,
            valueFormatter: params => moment(params?.value).format("DD/MM/YYYY")
        },
        { field: 'scheduleRbCbQuantity', headerName: 'Quantity(in MT)', width: 150 },
        {
            field: 'stakeholderUrn', headerName: 'URN(1stParty)', width: 150
        },
        {
            field: 'stakeholderContactNo', headerName: 'Contact Details(1stParty)', width: 150
        },
        {
            field: 'stakeholderLocationName', headerName: 'Location(1stParty)', width: 150
        },
        // {
        //     field: 'secondPartyUrn', headerName: 'URN(2ndParty)', width: 150,
        // },
        // {
        //     field: 'secondPartyContactNo', headerName: 'Contact Details(2ndParty)', width: 150,
        // },
        // {
        //     field: 'secondPartyLocationName', headerName: 'Location(2ndParty)', width: 150,

        // },
        {
            field: 'scheduledDeliveryDate', headerName: 'Delivery Date', width: 150,
            valueFormatter: params => moment(params?.value).format("DD/MM/YYYY")
        },
        { field: 'poStpoNumber', headerName: 'PO Number', width: 150 },
        { field: 'inventoryType', headerName: 'Type of Inventory', width: 150 },
        {
            field: 'Delete', width: 100,
            renderCell: (params) => {
                const canDelete =
                    params.row.scheduleStakeholderType === "LLE" &&
                    params.row.isConsignmentCreated !== true &&
                    params.row.isManuallyCreated === true;

                return (
                    <IconButton
                        disabled={!canDelete}
                        onClick={() => canDelete && onDeleteButtonClick(params.row)}
                    >
                        <DeleteIcon
                            style={{
                                color: canDelete ? "red" : "#ccc",
                                cursor: canDelete ? "pointer" : "not-allowed",
                            }}
                        />
                    </IconButton>
                );
            },
        },
    ];

    const columns1 = [
        { field: 'weeklyScheduleNumber', headerName: 'Schedule No', width: 250 },
        { field: 'scheduleLineNumber', headerName: 'Schedule Line No', width: 150 },
        {
            field: 'schedulePickupDate', headerName: 'Pick up Date', width: 150,
            valueFormatter: params => moment(params?.value).format("DD/MM/YYYY"),
        },
        { field: 'scheduleRbCbQuantity', headerName: 'Quantity(in MT)', width: 150 },
        {
            field: 'stakeholderUrn', headerName: 'URN(1stParty)', width: 150, hide: (tabValue === "Unloading" && stakeholderDetails?.category === "LLE"),
            renderCell: (cellValues) => {
                return (
                    tabValue === "Loading" ?
                        <>{cellValues?.row?.firstPartyType === stakeholderDetails?.category ? cellValues?.row?.stakeholderUrn : cellValues?.row?.firstPartyUrn}</>
                        :
                        <> {cellValues?.row?.stakeholderUrn} </>
                );
            }
        },
        {
            field: 'stakeholderContactNo', headerName: 'Contact Details(1stParty)', width: 150, hide: (tabValue === "Unloading" && stakeholderDetails?.category === "LLE"),
            renderCell: (cellValues) => {
                return (
                    tabValue === "Loading" ?
                        <>{cellValues?.row?.firstPartyType === stakeholderDetails?.category ? cellValues?.row?.stakeholderContactNo : cellValues?.row?.firstPartyContactNo}</>
                        :
                        <> {cellValues?.row?.stakeholderContactNo} </>
                );
            }
        },
        {
            field: 'stakeholderLocationName', headerName: 'Location(1stParty)', width: 150, hide: (tabValue === "Unloading" && stakeholderDetails?.category === "LLE"), renderCell: (cellValues) => {
                return (
                    tabValue === "Loading" ?
                        <>{cellValues?.row?.firstPartyType === stakeholderDetails?.category ? cellValues?.row?.stakeholderLocationName : cellValues?.row?.firstPartyLocationName}</>
                        :
                        <> {cellValues?.row?.stakeholderLocationName} </>
                );
            }
        },
        // {
        //     field: 'secondPartyUrn', headerName: 'URN(2ndParty)', width: 150,
        //     renderCell: (cellValues) => {
        //         return (
        //             tabValue === "Unloading" ?
        //                 <>{cellValues?.row?.secondPartyType === stakeholderDetails?.category ? cellValues?.row?.stakeholderUrn : cellValues?.row?.secondPartyUrn}</>
        //                 :
        //                 <> {cellValues?.row?.secondPartyUrn} </>
        //         );
        //     }
        // },
        // {
        //     field: 'secondPartyContactNo', headerName: 'Contact Details(2ndParty)', width: 150,
        //     renderCell: (cellValues) => {
        //         return (
        //             tabValue === "Unloading" ?
        //                 <>{cellValues?.row?.secondPartyType === stakeholderDetails?.category ? cellValues?.row?.stakeholderContactNo : cellValues?.row?.secondPartyContactNo}</>
        //                 :
        //                 <> {cellValues?.row?.secondPartyContactNo} </>
        //         );
        //     }
        // },
        // {
        //     field: 'secondPartyLocationName', headerName: 'Location(2ndParty)', width: 150,
        //     renderCell: (cellValues) => {
        //         return (
        //             tabValue === "Unloading" ?
        //                 <>{cellValues?.row?.secondPartyType === stakeholderDetails?.category ? cellValues?.row?.stakeholderLocationName : cellValues?.row?.secondPartyLocationName}</>
        //                 :
        //                 <> {cellValues?.row?.secondPartyLocationName} </>
        //         );
        //     }
        // },
        {
            field: 'scheduledDeliveryDate', headerName: 'Delivery Date', width: 150,
            valueFormatter: params => moment(params?.value).format("DD/MM/YYYY")
        },
        { field: 'poStpoNumber', headerName: 'PO Number', width: 150 },
        { field: 'inventoryType', headerName: 'Type of Inventory', width: 150 },
        {
            field: 'isScheduledApproved', headerName: 'Approval Status', width: 150,
            valueFormatter: (params) => {
                if (params.value === true) {
                    return 'Approved';
                }
                else if (params.value === false) {
                    return 'Rejected';
                }
                else {
                    return '';
                }
            },
            getCellValue: (params) => {
                if (params?.row?.scheduleStakeholderType === stakeholderDetails?.category) {
                    return <>{params?.row?.isScheduledApproved}</>;
                } else if (params?.row?.firstPartyType === stakeholderDetails?.category) {
                    return <>{params?.row?.isFirstPartyApproved}</>;
                } else {
                    return <>{params?.row?.isSecondPartyApproved}</>;
                }
            },
        },
        // { field: '', headerName: 'Action', width: 100 },
        {
            field: 'Delete', width: 100,
            renderCell: (params) => {
                const canDelete =
                    params.row.scheduleStakeholderType === "LLE" &&
                    params.row.isConsignmentCreated !== true &&
                    params.row.isManuallyCreated === true;

                return (
                    <IconButton
                        disabled={!canDelete}
                        onClick={() => canDelete && onDeleteButtonClick(params.row)}
                    >
                        <DeleteIcon
                            style={{
                                color: canDelete ? "red" : "#ccc",
                                cursor: canDelete ? "pointer" : "not-allowed",
                            }}
                        />
                    </IconButton>
                );
            },
        },

    ];

    const onConfirmApprove = (e) => {
        handleConfirmClose();
        onApprove(e);
    }

    const onApproveButtonClick = (e) => {
        var regex = /[-’/`~!#*$@_%+=^&(){}[\]|;:”<>?\\]/g;
        if (addComment == '' || addComment == null) {
            setErrorMessage({ ...errorMessage, noRecordError: "Please Enter Comment!" });
        }
        else if (regex.test(addComment)) {
            setErrorMessage({ ...errorMessage, noRecordError: "Please do not enter any special characters" });
        }

        else if (addComment.length > 500) {
            setErrorMessage({ ...errorMessage, noRecordError: "Please enter comments within 500 words" });
        }
        else {
            handleConfirmOpen();
        }
    }

    const onConfirmReject = (e) => {
        handleConfirmClose2();
        onReject(e);
    }

    const onRejectButtonClick = (e) => {
        handleConfirmOpen2();
    }

    const onApprove = () => {
        setErrorMessage({ ...errorMessage, noRecordError: "" });
        toApproveSchedule();
        setAddComment('');
    }

    const onReject = (e) => {
        var regex = /[-’/`~!#*$@_%+=^&(){}[\]|;:”<>?\\]/g;
        if (addComment == '' || addComment == null) {
            setErrorMessage({ ...errorMessage, noRecordError: "Please Enter Comment!" });
        }
        else if (regex.test(addComment)) {
            setErrorMessage({ ...errorMessage, noRecordError: "Please do not enter any special characters" });
        }

        else if (addComment.length > 500) {
            setErrorMessage({ ...errorMessage, noRecordError: "Please enter comments within 500 words" });
        }
        else {
            setErrorMessage({ ...errorMessage, noRecordError: "" });
            toApproveSchedule();
            setAddComment('');
        }

    }

    const toApproveSchedule = () => {
        loaderService.showLoader();
        apiClient
            .post(APPROVE_WEEKLY_SCHEDULE,
                {
                    "schedule_Id": scheduleList,
                    "scheduleApprovalComment": addComment?.scheduleApprovalComment,
                    //   "roleType": userLoggedIn 
                },
                {
                    headers: {
                        Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    }
                }, null
            )
            .then((response) => {
                setbulkApprovePo(response.data);
                getScheduleList();
                loaderService.hideLoader();
            })
            .catch(function (error) {
                console.log(error);
                loaderService.hideLoader();
                toast.error(error.message);
            });
    }

    useEffect(() => {
        if (bulkApprovePo) {
            if (bulkApprovePo.isSuccess === true) {
                toast.success(bulkApprovePo?.message)
                // handleLogModalOpen2();
            }
            else {
                toast.error(bulkApprovePo?.message ? bulkApprovePo?.message : "Error")
                // handleLogModalOpen();
            }
        }
    }, [bulkApprovePo]);


    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);
    }
    const onTextValueChange = (e) => {
        setAddComment(VALIDATION.noSpecialCharacterValidation(e.target.value.slice(0, 500)));
        setErrorMessage({ ...errorMessage, noRecordError: "" });
    }

    const onConfirmDelete = () => {
        handleConfirmClose3();
        onDelete();
    }

    const onDeleteButtonClick = (row) => {
        handleConfirmOpen3();
        setScheduleToDelete(row.id);
    }

    const onDelete = () => {
        onDeleteSchedule();
    }

    const onDeleteSchedule = () => {
        loaderService.showLoader();
        apiClient
            .post(
                DELETE_SCHEDULE,
                {
                    "scheduleId": scheduleToDelete,
                },
                {
                    headers: {
                        Authorization: "Bearer " + getLocalStorageItem('id_token'),
                    },
                },
                null
            )
            .then((response) => {
                setDeletedSchedules(response.data);
                getScheduleList();
                loaderService.hideLoader();
            })
            .catch(function (error) {
                console.log(error);
                loaderService.hideLoader();
                toast.error(error.message);
            });
    };

    useEffect(() => {
        if (deletedSchedules) {
            if (deletedSchedules.isSuccess === true) {
                toast.success(deletedSchedules?.message)
            } else {
                toast.error(deletedSchedules?.message ? deletedSchedules?.message : "Error")
            }
        }
    }, [deletedSchedules]);

    return (
        <>
            <Container maxWidth="xxl">
                {!PROD && <p style={{ textAlign: "center", fontSize: "2vh" }}>PIT53</p>}
                <Typography variant="h4" gutterBottom>
                    Weekly Chipping Schedules
                </Typography>
                <Card>
                    <TabContext value={tabValue} style={{ marginLeft: "1.5vh" }}>
                        <Box sx={{ borderBottom: 1, borderColor: 'divider', bgcolor: 'whitesmoke' }}>
                            <TabList onChange={handleTabChange} aria-label="lab API tabs example">
                                <Tab label="Schedules" value="Pending" />
                                <Tab label="Approved Schedules" value="Approve" />
                            </TabList>
                        </Box>
                        <TabPanel value="Pending">
                            <Box style={{ height: 445, width: '100%' }}>
                                {
                                    scheduleListData &&
                                    <DataGrid rows={scheduleListData}
                                        columns={columns}
                                        pageSize={10}
                                        checkboxSelection
                                        components={{ Toolbar: QuickSearchToolbar }}
                                        onSelectionModelChange={(newSelection) => {
                                            setscheduleList(newSelection.map(row => {
                                                let sNo = ""
                                                scheduleListData.forEach(so => {

                                                    if (row === so.id) {
                                                        sNo = so.id;
                                                    }

                                                })
                                                return sNo;
                                            }));
                                        }}
                                    />
                                }
                            </Box>
                            <Grid container mt={2}>
                                <Grid item xs={12} md={6}>
                                    <TextField fullWidth required
                                        error={errorMessage.noRecordError}
                                        helperText={errorMessage.noRecordError}
                                        autoComplete="off"
                                        id="outlined-multiline-static"
                                        label="Comments"
                                        multiline
                                        rows={4}
                                        onChange={(e) => onTextValueChange(e)}
                                        value={addComment}
                                        disabled={scheduleList.length < 1}
                                        sx={{ paddingRight: '15%' }}
                                    />
                                    <div style={{ display: 'flex', justifyContent: 'flex-end', paddingRight: '10%' }}>
                                        <Badge bg={`${addComment?.length > characterLimit ? 'danger' : 'primary'}`}>{addComment?.length}/{characterLimit}</Badge>
                                    </div>
                                </Grid>
                            </Grid>
                            <Box display='flex' mb={2} alignItems="center" justifyContent="center" mt={3} style={{ float: "right" }}>
                                <Button startIcon={<ApproveIcon />} sx={{ minWidth: 100 }} variant="contained" disabled={scheduleList.length < 1} type="submit" onClick={(e) => onApproveButtonClick(e)}>Approve</Button>
                                {/* <Button sx={{ minWidth: 100, ml: 1 }} variant="contained" disabled={scheduleList.length < 1} type="submit" onClick={(e) => onRejectButtonClick(e)}>Reject</Button> */}
                            </Box>
                        </TabPanel>
                        <TabPanel value="Approve">
                            <Box style={{ height: 445, width: '100%', marginTop: "2vh" }}>
                                {
                                    scheduleListData &&
                                    <DataGrid rows={scheduleListData}
                                        columns={columns1}
                                        pageSize={10}
                                        components={{ Toolbar: QuickSearchToolbar }}
                                    />
                                }
                            </Box>

                        </TabPanel>
                    </TabContext>
                </Card>

            </Container>
            <ConfirmationPopover onOpen={confirmOpen} onConfirm={onConfirmApprove} onClose={handleConfirmClose} action="Approve" />
            <ConfirmationPopover onOpen={confirmOpen2} onConfirm={onConfirmReject} onClose={handleConfirmClose2} action="Reject" />
            <ConfirmationPopover onOpen={confirmOpen3} onConfirm={onConfirmDelete} onClose={handleConfirmClose3} action="Delete Schedule" />

            <Dialog maxWidth='xs' fullWidth open={logModalOpen}>
                <DialogContent>
                    <ErrorPopover title={"ERROR"} navigate={navigate} goToStakeHolderDashboard="goToStakeHolderDashboard" hideLink={true} />
                </DialogContent>
            </Dialog>
            <Dialog maxWidth='xs' fullWidth open={logModalOpen2}>
                <DialogContent>
                    <ConfirmPopover title={bulkApprovePo?.message ? bulkApprovePo?.message : "Error"} hideLink={true} />
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleLogModalClose2}>OK</Button>
                </DialogActions>
            </Dialog>
        </>
    );
}
export default ChippingApproval;
